export const GET_ADDRESS = "GET_ADDRESS";
export const ALL_ADDRESS = "ALL_ADDRESS";
export const EDIT_ADDRESS = "EDIT_ADDRESS";
export const ADD_ADDRESS = "ADD_ADDRESS";





